import React, { useEffect, useState } from 'react';
import { Button, FormGroup, Input, Label } from 'reactstrap';
import PropTypes from 'prop-types';

import Modal from '../../../ui/Modal';

const blockEl = 'invoices__add-note-modal';

const AddNoteModal = ({
  isOpen,
  onClose,
  onSave,
  notes,
  totalInvoices,
  variant,
  modalNameObject,
}) => {
  const isBulk = variant === 'bulk';
  const hasNote = (notes && notes.length > 0);
  const [notesValue, setNotesValue] = useState(notes);
  const [buttonDisabled, setButtonDisabled] = useState(!isBulk && !hasNote);

  useEffect(() => {
    setButtonDisabled(notesValue === '');
  }, [notesValue]);

  const renderDetailsContent = () => {
    let content = '';

    if (isBulk) {
      content = (
        <>
          <p>The note below will be added to all selected ({totalInvoices}) invoices. </p>
          {content}
        </>
      );
    } else {
      content = (
        <div className="mb-n2">
          <div>
            <span className="font-weight-bold">{modalNameObject.name}</span>
            {modalNameObject.paddleNumber && (
              <span> (Paddle #{modalNameObject.paddleNumber})</span>
            )}
          </div>
          <div>
            Invoice # {modalNameObject.id} | {modalNameObject.location} | {modalNameObject.channel}
          </div>
        </div>
      );
    }

    return content;
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();

    onSave(notesValue);
  };

  const updateNotesValue = () => {
    setNotesValue(document.getElementById('newNote').value);
  };

  return (
    <Modal isOpen={isOpen} className={blockEl} toggle={onClose}>
      <form onSubmit={handleOnSubmit} noValidate>
        <Modal.Header toggle={onClose}>
          {hasNote ? (
            <span>Edit Note</span>
          ) : (
            <span>Add a Note</span>
          )}
        </Modal.Header>
        <Modal.Body>
          {renderDetailsContent()}
          <FormGroup>
            <Label for="newNote">
              {hasNote ? (
                <span>Edit Note</span>
              ) : (
                <span>Add New Note</span>
              )}
            </Label>
            <Input
              type="textarea"
              id="newNote"
              name="notes"
              rows="9"
              defaultValue={notes}
              onChange={(e) => updateNotesValue(e)}
            />
          </FormGroup>
        </Modal.Body>
        <Modal.Footer>
          <Button type="button" color="link" onClick={onClose}>Cancel</Button>
          <Button type="submit" color="primary" disabled={buttonDisabled}>
            {hasNote ? (
              <span>Save Updates</span>
            ) : (
              <span>Add Note</span>
            )}
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};

AddNoteModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onSave: PropTypes.func,
  notes: PropTypes.string,
  totalInvoices: PropTypes.number,
  variant: PropTypes.oneOf(['bulk', 'single']),
};

AddNoteModal.defaultProps = {
  isOpen: false,
  onClose: Function.prototype,
  onSave: Function.prototype,
  totalInvoices: 0,
  notes: '',
  variant: 'single',
};

export default AddNoteModal;
